import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Container = ({ className = "", children }) => (
  <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
);

export const SectionHeader = ({ eyebrow, title, text, action, testid }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12" data-testid={testid}>
    <div className="max-w-2xl reveal">
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0B1F44]">{title}</h2>
      {text && <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">{text}</p>}
    </div>
    {action}
  </div>
);

export const MoreLink = ({ to, children, testid }) => (
  <Link to={to} className="inline-flex items-center gap-2 text-sm font-semibold text-blue-700 hover:gap-3 transition-[gap]" data-testid={testid}>
    {children} <ArrowRight className="h-4 w-4" />
  </Link>
);

export const PageHero = ({ eyebrow, title, text }) => (
  <section className="pt-36 pb-16 bg-gradient-to-b from-slate-100 to-white border-b border-slate-200 court-lines" data-testid="page-hero">
    <Container>
      <p className="eyebrow mb-3 reveal">{eyebrow}</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0B1F44] max-w-4xl reveal" style={{ animationDelay: "80ms" }}>{title}</h1>
      {text && <p className="mt-5 text-base md:text-lg text-slate-600 max-w-2xl reveal" style={{ animationDelay: "160ms" }}>{text}</p>}
    </Container>
  </section>
);

export const SmartLink = ({ to = "/", className, testid, children }) =>
  /^(https?:|mailto:|tel:)/.test(to) ? (
    <a href={to} target={to.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className={className} data-testid={testid}>{children}</a>
  ) : (
    <Link to={to} className={className} data-testid={testid}>{children}</Link>
  );

export const Empty = ({ children, testid }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500" data-testid={testid}>{children}</div>
);

export const Loading = () => (
  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
    {[0, 1, 2].map((i) => <div key={i} className="h-64 rounded-2xl bg-slate-200/70 animate-pulse" />)}
  </div>
);

const STATUS = {
  Upcoming: "bg-blue-50 text-blue-700 ring-blue-200",
  Ongoing: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  Completed: "bg-slate-100 text-slate-600 ring-slate-200",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${STATUS[status] || STATUS.Completed}`}>{status}</span>
);
